if (document.getElementById('vue-search')) {
	Vue.use(VeeValidate)
	new Vue({
		mixins: [baseMixin, eventHubMixin],
		el: '#vue-search',
		data: {
			jobs: [],
			posts_per_page: 6,
			offset: 0,
			loading: true,
			hasNext: false,
			toggled: false,
			locations: [],
			industries: [],
			redirect: false,
			baseUrl: jobsUrl.replace(/.$/, '?'),

			form_fields: {
				keywords: {
					label: 'Trouvez une offre...',
					component: 'input',
					optional: false,
					api_key: 'keywords',
					model: {}
				},
				location: {
					iconType: 'ico-pin',
					label: 'Région',
					default: 'Région',
					component: 'select',
					api_key: 'wpbb_job_location',
					options: [],
					model: {
						value: ''
					}
				},
				industry: {
					iconType: 'ico-tag',
					label: 'Secteur',
					default: 'Secteur',
					component: 'select',
					api_key: 'wpbb_job_industry',
					options: [],
					model: {}
				}
			}
		},
		created() {},
		mounted() {
			this.redirect = this.$refs.listing ? false : true
			// console.log(this.baseUrl)

			this.getOptions('location', 'locations', () => {
				this.getOptions('industry', 'industries', () => {
					this.initModels()
				})
			})
		},
		methods: {
			initModels() {
				if (!this.redirect) {
					const params = new URLSearchParams(window.location.search)
					Object.keys(this.form_fields).map((key) => {
						const field = this.form_fields[key]
						const val = params.get(field.api_key)

						if (val) {
							field.model.value = val

							if (field.options) {
								field.model.label = field.options.find(
									(o) => o.value === parseInt(val)
								).label
							}
						}
					})

					this.getJobs()
				}
			},

			getOptions(key, data, callback) {
				axios({
					method: 'GET',
					url: `/wp-json/wp/v2/wpbb_job_${key}?per_page=50`
				}).then((response) => {
					// console.log(response.data);
					if (response.data.length) {
						this[data] = response.data.map((el) => {
							return {
								label: el.name,
								value: el.id
							}
						})
					}
					this.form_fields[key].options = this[data]
					callback()
				})
			},

			filterJobs() {
				if (this.redirect) {
					this.goToOffers()
				} else {
					this.getJobs()
				}
			},

			getJobs(clear = true) {
				this.loading = true

				if (clear) {
					this.jobs = []
				}

				let data = this.getFormData(clear)

				axios({
					method: 'POST',
					url: '/wp-json/sophia/v1/broadbeanJobs',
					data: data
				}).then((response) => {
					this.jobs = this.jobs.concat(response.data.jobs)
					this.loading = false
					this.hasNext = response.data.hasNext
				})
			},

			getFormData(clear = false) {
				let form = new FormData()

				form.append('posts_per_page', this.posts_per_page)

				Object.keys(this.form_fields).forEach((key) => {
					let field = this.form_fields[key]

					if (field.model.value) {
						form.append(key, field.model.value)
					}
				})

				if (!clear) {
					form.append('offset', this.jobs.length)
				}

				return form
			},

			goToOffers() {
				let baseUrl = this.baseUrl

				window.location = Object.keys(this.form_fields).reduce((prev, curr) => {
					const field = this.form_fields[curr]
					return field.model.value != ''
						? `${prev}${field.api_key}=${encodeURIComponent(
								field.model.value
						  )}&`
						: prev
				}, baseUrl)
			},

			toggleSearch() {
				this.toggled = !this.toggled
			}
		},
		watch: {
			// form_fields: {
			//     handler: function (newValue, oldValue) {
			//         if (newValue.location.model.label != undefined) {
			//             // this.changePlaceholder('location', newValue.location.model.label);
			//         }
			//         if (newValue.sector.model.label != undefined) {
			//             // this.changePlaceholder('sector', newValue.sector.model.label);
			//         }
			//     },
			//     deep: true
			// }
		}
	})
}
